import React from 'react';
import NumberFormat from 'react-number-format';

function sumByQtde(rowsCount, rowGetter, column) {
  let rows = 0;
  let totalQtde = 0;
  for (let index = 0; index < rowsCount; index++) {
    const columnValue = rowGetter(index)[column.key];
    if (!columnValue) continue;
    if(columnValue > 0) { rows = rows + 1 }
    totalQtde += columnValue;
  }
  if(rows === 0) return totalQtde;
  return totalQtde/rows;
}

export default function CurrencySummary({ rowsCount, rowGetter, column }) {
  return (
    <div className="d-flex justify-content-end">
      <NumberFormat
        displayType="text"
        thousandSeparator="."
        decimalSeparator=","
        prefix={'R$'}
        decimalScale={2}
        fixedDecimalScale={true}
        value={sumByQtde(rowsCount, rowGetter, column)}
      />
    </div>
  )
}
